<template>
  <div class="container">
    <common-title titleName="订单详情" />
    <div class="tabs">
      <div class="tab" @click="toggleTab(1)">
        <div :class="[activeIndex === 1 ? 'active' : '']">购课信息</div>
        <div v-show="activeIndex === 1" class="icon"></div>
      </div>
      <div class="middle"></div>
      <div class="tab" @click="toggleTab(2)">
        <div :class="[activeIndex === 2 ? 'active' : '']">发货信息</div>
        <div v-show="activeIndex === 2" class="icon"></div>
      </div>
    </div>
    <div class="content">
      <div v-if="activeIndex === 1 && !deliveryInfo.length && !showEditForm && toggleDisbale && jugeFleds(detail)" class="toggleBtn" @click="toggle">更改信息</div>
      <order-detail v-show="activeIndex === 1 && !showEditForm" :detail="detail"/>
      <order-form v-show="activeIndex === 1 && showEditForm" :detail="detail" :onSuccess="onSuccess" />
      <div v-show="activeIndex === 2">
        <div v-if="deliveryInfo.length === 0" class="defaultEmpty">
          <img :src="urls[1]" alt="未发货" class="img">
          <div>该订单目前还未发货～</div>
        </div>
        <div v-else>
          <div v-for="item in deliveryInfo" :key="item.expressNo" class="cardItem">
            <div class="title">
              <div class="leftIcon"></div>
              <div class="right">
                <div class="text">
                  {{ `${item.expressName}：${item.expressNo}`}}
                  <img
                    :src="urls[0]"
                    class="img"
                    alt="复制"
                    v-clipboard:copy="item.expressNo"
                    v-clipboard:success="handleCopy"
                  >
                </div>
              </div>
            </div>
            <div class="content">
              <div class="name" v-for="goodName in item.goodsNameList" :key="goodName">
                {{ goodName }}
              </div>
              <div class="bottom">
                <div>共{{ item.goodsNameList.length }}本</div>
                <div class="btn" @click="openPopUp(item.expressNo)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LogisticsDetail :showDetail="showDetail" :deliverData="handData" @close="close" />
  </div>
</template>

<script>
import {
  reqBilibiliOrderDetail,
  reqBilibiliOrdereliverDetail,
} from '@/api/bilibiliShipments/index';
import CommonTitle from '@/components/header/CommonTitle.vue';
import orderDetail from './components/orderDetail.vue';
import orderForm from './components/orderForm.vue';
import LogisticsDetail from '../personalCenter/logistics/component/logisticsDetail.vue';

export default {
  components: {
    CommonTitle,
    orderDetail,
    orderForm,
    LogisticsDetail,
  },
  data() {
    return {
      urls: [`${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%9F%A9%E5%BD%A2%E5%A4%87%E4%BB%BD%202%402x.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%202%402x%20(1).png`],
      activeIndex: 1,
      detail: {},
      deliveryInfo: [],
      showDetail: false,
      handData: {},
      showEditForm: false,
      toggleDisbale: false,
    };
  },
  created() {
    this.getOrderInfo();
    this.getDeliveryInfo();
  },
  methods: {
    jugeFleds(detail) {
      if (detail.bproductId && Number(detail.bproductId) !== 1418) {
        return true;
      }
      return false;
    },
    toggle() {
      this.showEditForm = true;
    },
    toggleTab(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
    },
    onSuccess() {
      this.$toast('编辑成功');
      this.showEditForm = false;
      this.getOrderInfo();
    },
    async getOrderInfo() {
      const { orderNo } = this.$route.params;
      const { bproductId } = this.$route.query;
      const res = await reqBilibiliOrderDetail(orderNo, bproductId);
      if (res.code === 0) {
        this.detail = res.data;
      }
    },
    async getDeliveryInfo() {
      const { orderNo } = this.$route.params;
      const res = await reqBilibiliOrdereliverDetail(orderNo);
      if (res.code === 0) {
        this.deliveryInfo = res.data;
        this.toggleDisbale = true;
        return;
      }
      this.toggleDisbale = false;
    },
    handleCopy() {
      this.$toast('复制成功');
    },
    openPopUp(expressNo) {
      const { phone } = this.$route.query;
      this.handData = { expressNo, phone };
      this.showDetail = true;
    },
    close() {
      this.showDetail = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.container {
  padding-top: 100px;
  background: #F7F8FC;
}
.tabs {
  display: flex;
  padding: 22px 127px 0 127px;
  font-size: 29px;
  font-weight: 500;
  color: #333333;
  background: #fff;
  line-height: 40px;

  .tab {
    .icon {
      width: 45px;
      height: 5px;
      margin: 22px 0 0 36px;
      background: #FF7F41;
    }

    .active {
      color: #FF7F41;
    }

  }

  .middle {
    width: 2px;
    height: 25px;
    background: #E1E1E1;
    margin: 0 124px;
  }
}

.content {
  .toggleBtn {
    width: 100%;
    padding: 36px;
    text-align: end;
    font-size: 25px;
    color: #FF7F41;
  }
  .defaultEmpty {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 25px;
    color: #333333;

    .img {
      width: 290px;
      height: 217px;
      margin: 239px 0 18px 0;
    }
  }
  .cardItem {
    margin-top: 22px;
    padding: 0 36px;
    background: #FFFFFF;
    border-radius: 14px;

    .title {
      display: flex;
      align-items: center;
      padding: 29px 0;
      font-size: 25px;

      .leftIcon {
        width: 7px;
        height: 29px;
        margin-right: 29px;
        background: #FF7F41;
      }

      .right {
        display: flex;
        flex: 1;
        justify-content: space-between;
        .text {
          display: flex;
          align-items: center;
          color: #999999;
        }
        .img {
          width: 33px;
          height: 33px;
        }
      }
    }

    .content {
      padding: 22px 0 36px 29px;
      border-top: 2px solid #F6F6F6;

      .name {
        margin-bottom: 22px;
        font-size: 29px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }

      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 25px;
        color: #FE7F41;

        .btn {
          width: 170px;
          height: 58px;
          background: #FE7F41;
          border-radius: 29px;
          text-align: center;
          color: #fff;
          font-size: 25px;
          line-height: 58px;
        }

      }

    }
  }
}
</style>
